import { Guid } from '@web/utils';
import { Multimedia } from '@web/shared/module/multimedia';
import { PublicBoxCosmeticBrand } from './public-box-cosmetic-brand';

export class PublicBoxCosmetic {
  public constructor(
    private readonly data: {
      id: Guid;
      name: string;
      brand: PublicBoxCosmeticBrand;
      slug: string;
      featuredFile: Multimedia;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get name(): string {
    return this.data.name;
  }

  public get brand(): PublicBoxCosmeticBrand {
    return this.data.brand;
  }

  public get slug(): string {
    return this.data.slug;
  }

  public get featuredFile(): Multimedia {
    return this.data.featuredFile;
  }
}
